export const RolesEnum = {
  LimitedGuest: "b4292599-057a-40c3-97eb-2e277708fd9f",
  FieldEnumerator: "4463887d-4a4d-46f9-8695-4726f84aeff3",
  Guest: "d4d85e83-a7e1-4d7d-9910-54be5438c524",
  FieldTeamLeader: "8c2c1d7a-b10d-4696-8a52-61277a2f02d1",
  FieldLogistics: "153aca73-95d4-46b5-9bcb-6a91f3155135",
  ProjectManager: "615a8dc6-ca07-4f82-8d0d-7d82dd4d3ef8",
  FieldCoordinator: "e78550f4-c017-4ec7-94e8-e040090c32b1",
  SystemAdmin: "4714234f-c988-43a8-a817-f6d5251bf128",
  DataAnalyst: "534bb5b2-b62d-40fb-a89c-bc95ad80cbe6",
};
